"use strict";

exports.__esModule = true;
exports.isDef = isDef;
exports.isKorean = isKorean;
function isDef(val) {
  return val !== undefined && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/utils/shared.js
// module id = 56
// module chunks = 0